export const PAGE_TITLES = {
  BUSINESS_SETTINGS: 'Business Settings',
  EMAIL_SMS_TRIGGER: 'Email Trigger Details',
};
